export default __webpack_public_path__ + "city-map-500-6ba9ea415cfb27d2513dc84a736b72f7.png";